import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

import { LoginState } from "../../model";
import { url } from "../../utils/config";
import { serverMessage } from "../../utils/serverMessage";
import { setToken } from "../../utils/tokenStorage";
import { setUserDetails } from "../../utils/userStorage";
import { delayMessage } from "../../utils/delayMessage";

const initialState: LoginState = {
  loginLoading: false,
  loginDisable: false,
  loginUser: {
    email: "",
    password: "",
  },
  pendingRequestTimer: null,
};

export const login = createAsyncThunk(
  "login/login",
  async (details: any, thunkAPI) => {
    try {
      const { loginUser, navigate } = details;
      const { data } = await axios.post(`${url.baseUrl}/login`, loginUser);
      setUserDetails(data.data.data); // Save user profile object to local storage
      navigate("/dashboard"); // Navigate to dashboard
      return data;
    } catch (error: any) {
      console.log(error.response.data.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    // Collect input values in the login input fields
    getLoginValues: (
      state,
      { payload }: PayloadAction<{ name: keyof LoginState; value: any }>
    ) => {
      const { name, value } = payload;
      state.loginUser = { ...state.loginUser, [name]: value };
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loginLoading = true;
        state.loginDisable = true;
        state.pendingRequestTimer = setTimeout(delayMessage, 10000);
      })
      .addCase(login.fulfilled, (state, { payload }) => {
        toast.success(payload.data.message);
        setToken(payload.data.token); // Store token
        state.loginLoading = false;
        state.loginDisable = false;
        state.loginUser.email = "";
        state.loginUser.password = "";
        // Clear timeout
        state.pendingRequestTimer && clearTimeout(state.pendingRequestTimer);
      })
      .addCase(login.rejected, (state, { payload }) => {
        serverMessage(payload);
        state.loginLoading = false;
        state.loginDisable = false;
        // Clear timeout
        state.pendingRequestTimer && clearTimeout(state.pendingRequestTimer);
      });
  },
});

export default loginSlice.reducer;

export const { getLoginValues } = loginSlice.actions;
